import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbDialogRef, NbWindowService } from '@nebular/theme';
import { OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { OfbizSummaryWindowComponent } from '@urbannex/ofbiz-forms';
import { ComponentConfig } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { ViewContainersService } from '../shared/services/view-containers.service';

@Component({
  selector: 'ubs-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss'],
  providers:[UbsComponentStoreService]
})
export class DialogContainerComponent implements OnInit {
  @Input() title: string;
  @Input() data:any;
  @Input() fieldList:any[];
  @Input() activeLevel:number;
  @Input() action:string;
  @Input() componentConfig:ComponentConfig;

  existingValues:any;
  state:any;
  form: FormGroup;
  formFields:any[];
  
  ofbizForm:OfbizForm;
  addForms:OfbizForm[] = [];
  findForms:OfbizForm[] = [];
  listForms:OfbizForm[] = [];
  
  constructor(protected ref: NbDialogRef<DialogContainerComponent>,
    private windowService: NbWindowService,
    private componentStore:UbsComponentStoreService,
    private viewContainersService:ViewContainersService) { 

    }

  ngOnInit(): void {
    //console.log({TrackDialog:{"data":this.data,"fieldList":this.fieldList,"activeLevel":this.activeLevel,"componentConfig":this.componentConfig,"ofbizForm":this.ofbizForm}});
    let entries = Object.entries(this.componentConfig)
    this.addForms = this.viewContainersService.getForms(entries,this.addForms,"addForm");
    this.listForms = this.viewContainersService.getForms(entries,this.listForms,"listForm");
    this.findForms = this.viewContainersService.getForms(entries,this.findForms,"findForm");
    this.ofbizForm = this.addForms[this.activeLevel-1];
    
    console.log({TrackDialog:{"data":this.data,"fieldList":this.fieldList,"activeLevel":this.activeLevel,"ofbizForm":this.ofbizForm}});
    this.existingValues = this.data;
    
    /* this.ofbizFormService.getFormFields(this.fieldList)
    .subscribe((formFields) => {
      let keys = Object.keys(this.existingValues);
      if(formFields){
        keys.forEach(key => {
          let field = formFields.find(field => field.name == key);
          if(field){
            field["value"] = this.existingValues[key];
          }
        });
      }
      console.log({"formFields":formFields});
      this.formFields = formFields;
      this.form = this.ofbizFormService.toFormGroup(formFields);
    }); */
  }

  onSubmit(){
    console.log({TrackDialog:{"formValue":this.form.value}});
  }

  dismiss(){
    this.ref.close("success");
  }

  resetAction(event){
    this.dismiss()
    /* console.log({resetActionEvent:event});
    console.log({activeLevel:this.activeLevel});
    console.log({selectedValue:this.state["selectedValue"]});
    this.componentStore.updateAction(event); */

    //this.componentStore.updateActiveLevel(this.activeLevel);
    //console.log({ActionEvent:getEnumKeyByEnumValue(ActionState,event)});
  }

  openSummary(){
    console.log(this.state);
    this.ref.close();
    this.windowService.open(OfbizSummaryWindowComponent, 
      { title: this.state.workSpaceState+" Overview",
        context:{"componentConfig":this.state,fieldList:this.fieldList,existingValues:this.existingValues},
        windowClass: 'window-limited-height'
      }
    );
  }

}
